
export class ApplicationError implements Error {
    private _statusCode: string;
    private _statusMsg: string;
    private _cause: any;
    private _message: string = null;
    private _httpStatusCode: number;

    constructor(statusCode: string, statusMsg: string, cause: any) {
        this._message = "Applciation error. Code[" + statusCode + "], Msg[" + statusMsg + "]";
        this._statusCode = statusCode;
        this._statusMsg = statusMsg;
        this._cause = cause;
    }

    public get message(): string {
        return this._message;
    }
    public set message(statusCode: string) {
        this._message = statusCode;
    }

    public get name(): string {
        return (<any>this).constructor.name;
    }

    public get statusCode(): string {
        return this._statusCode;
    }
    public set statusCode(statusCode: string) {
        this._statusCode = statusCode;
    }

    public get statusMsg(): string {
        return this._statusMsg;
    }
    public set statusMsg(statusMsg: string) {
        this._statusMsg = statusMsg;
    }

    public get httpStatusCode(): number {
        return this._httpStatusCode;
    }
    public set httpStatusCode(httpStatusCode: number) {
        this._httpStatusCode = httpStatusCode;
    }

}
// To extend Error 
(<any>Object).setPrototypeOf(ApplicationError.prototype, Error.prototype);


// WEBPACK FOOTER //
// ./src/app/common/error.model.ts